import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';

import { logger } from '@luna/logger';

interface Props {
    errorFallback: ReactNode;
    children: ReactNode;
    onErrorCleanup(): void;
}

export class LazyComponentErrorBoundary extends Component<Props> {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error | null, __errorInfo: ErrorInfo) {
        logger.error('LazyComponentErrorBoundary', error, __errorInfo);
    }

    componentWillUnmount(): void {
        if (!this.state.hasError) {
            return;
        }

        this.props.onErrorCleanup();
    }

    render() {
        if (this.state.hasError) {
            return this.props.errorFallback;
        }

        return this.props.children;
    }
}
